import React from 'react';
import sendEvent from '../../helpers/tracking';

import './ProductListOverview.scss';

export default function ProductListOverview({
  title, text, list, formXuid, returnTo
}) {
  return (
    <div className="productListOverview">
      <h2 className="productListOverview-title">{title}</h2>

      <div className="productListOverview-text">
        {text.map((p, idx) =>
          <p className="productListOverview-text-paragraph" key={idx}>
            {p}
          </p>)}
      </div>

      <ul className="productListOverview-list">
        {list.map((item, idx) =>
          <li key={idx}>
            <span className="productListOverview-list-item-marker">
              {idx + 1}
            </span>
            <p className="productListOverview-list-item-text">{item}</p>
          </li>)}
      </ul>

      <div className="productListOverview-buttons">
        <button
          className="
            productListOverview-button
            productListOverview-button-secondary"
          onClick={() => {
            sendEvent('circulareconomy_lander',
              'circulareconomy_lander_informatie');

            location.href =
              `/circulaire-gebruik-van-babyspullen-hoe-gaat-het-huren-bij-ons-in-zijn-werk`
          }}
        >
          Meer informatie
        </button>

        <button
          className="
            productListOverview-button
            productListOverview-button-primary"
          onClick={() => {
            sendEvent('circulareconomy_lander', 'circulareconomy_lander_bestellen');

            location.href =
              `/form-answers/create/${formXuid}/anonymous?alternativeView=true&returnTo=${returnTo}`
          }}
        >
          Bestellen
        </button>
      </div>
    </div>
  );
}
